import { render, staticRenderFns } from "./CbsQuickConfigChildrenTodo.vue?vue&type=template&id=275d035c&scoped=true&"
import script from "./CbsQuickConfigChildrenTodo.vue?vue&type=script&lang=js&"
export * from "./CbsQuickConfigChildrenTodo.vue?vue&type=script&lang=js&"
import style0 from "./CbsQuickConfigChildrenTodo.vue?vue&type=style&index=0&id=275d035c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275d035c",
  null
  
)

/* custom blocks */
import block0 from "@/locales/modules/TodoListTranslate.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Flike%2FDocuments%2FComay%2FSources%2FFe%2Flink-fe%2Fsrc%2Fcomponents%2Fcbs-quick-config-children-todo%2FCbsQuickConfigChildrenTodo.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports